import { Store, Module, ActionContext } from "vuex";
import ListModule from "../list-module";
import ListState from "../list-state";
import Ajax from "../../../lib/ajax";
import PageResult from "@/store/entities/page-result";
import ListMutations from "../list-mutations";
import Order from "../../entities/booking/order";

interface OrderState extends ListState<Order> {
  offlineOrderList: Order[];
  editOrder: Order;
  offlineTotalCount: number;
  offlineCurrentPage: number;
  offlinePageSize: number;
  offlineLoading: boolean;
}
class OrderMutations extends ListMutations<Order> {}
class OrderModule extends ListModule<OrderState, any, Order> {
  state = {
    totalCount: 0,
    currentPage: 1,
    pageSize: 10,
    list: new Array<Order>(),
    offlineOrderList: new Array<Order>(),
    loading: false,
    offlineLoading: false,
    editOrder: new Order(),
    offlineTotalCount: 0,
    offlineCurrentPage: 1,
    offlinePageSize: 10,
  };
  actions = {
    async getAll(context: ActionContext<OrderState, any>, payload: any) {
      context.state.loading = true;
      let reponse = await Ajax.get("/api/services/app/Order/GetAll", {
        params: payload.data,
      });
      context.state.loading = false;
      let page = reponse.data.result as PageResult<Order>;
      context.state.totalCount = page.totalCount;
      context.state.list = page.items;
    },
    /**
     *
     * @param context
     * @param payload
     * @description:为了处理线上订单计时器影响线下订单
     */
    async getOfflineAll(context: ActionContext<OrderState, any>, payload: any) {
      context.state.offlineLoading = true;
      let reponse = await Ajax.get("/api/services/app/Order/GetAll", {
        params: payload.data,
      });
      context.state.offlineLoading = false;
      let page = reponse.data.result as PageResult<Order>;
      context.state.offlineTotalCount = page.totalCount;
      context.state.offlineOrderList = page.items;
    },
    async create(context: ActionContext<OrderState, any>, payload: any) {
      await Ajax.post("/api/services/app/Order/Create", payload.data);
    },
    async update(context: ActionContext<OrderState, any>, payload: any) {
      await Ajax.put("/api/services/app/Order/Update", payload.data);
    },
    async exportOrder(context: ActionContext<OrderState, any>, payload: any) {
      return await Ajax.get("/api/services/app/Order/ExportOrder", {
        params: payload.data,
      });
    },
    async delete(context: ActionContext<OrderState, any>, payload: any) {
      await Ajax.delete("/api/services/app/Order/Delete?Id=" + payload.data.id);
    },
    async onlineToOffline(
      context: ActionContext<OrderState, any>,
      payload: any
    ) {
      return await Ajax.get(
        `/api/services/app/Order/OnlineToOffline?orderId=${
          payload.id
        }&supplierId=${payload.supplierId}`
      );
    },
    async updateOrderInRefund(
      context: ActionContext<OrderState, any>,
      payload: any
    ) {
      return await Ajax.put(
        "/api/services/app/Order/UpdateOrderInRefund",
        payload.data
      );
    },
    async get(context: ActionContext<OrderState, any>, payload: any) {
      console.log(payload);
      let reponse = await Ajax.get(
        "/api/services/app/Order/Get?Id=" + payload.id
      );
      return reponse.data.result as Order;
    },
    async SendSmsToUser(context: ActionContext<OrderState, any>, payload: any) {
      let reponse = await Ajax.post(
        "/api/services/app/Order/SendSmsToUser",
        payload.data
      );
      return reponse;
    },

    async sendSmsToUserPay(
      context: ActionContext<OrderState, any>,
      payload: any
    ) {
      let reponse = await Ajax.get(
        "/api/services/app/Order/SendSmsToUserPay?orderId=" + payload.id
      );
      return reponse;
    },
    async UpdateOrderTeeDates(
      context: ActionContext<OrderState, any>,
      payload: any
    ) {
      const data = {
        orderTeeDates: payload.orderTeeDates,
      };
      let reponse = await Ajax.put(
        "/api/services/app/Order/UpdateOrderTeeDates",
        data
      );
      return reponse;
    },
  };
  mutations = {
    setCurrentPage(state: OrderState, page: number) {
      state.currentPage = page;
    },
    setOfflineCurrentPage(state: OrderState, page: number) {
      state.offlineCurrentPage = page;
    },
    setOfflinePageSize(state: OrderState, pagesize: number) {
      state.offlinePageSize = pagesize;
    },
    setPageSize(state: OrderState, pagesize: number) {
      state.pageSize = pagesize;
    },
    edit(state: OrderState, order: Order) {
      state.editOrder = order;
    },
  };
}
const orderModule = new OrderModule();
export default orderModule;
